import create from "zustand";
import { getEnvironment } from "src/utils/getEnvironment";
import { Environment } from "src/constants/auth.constants";

interface MaintenanceState {
  maintenanceDev: boolean;
  setMaintenance: (value: boolean) => void;
}

const environment = getEnvironment();

export const useMaintenanceDev = create<MaintenanceState>((set) => ({
  maintenanceDev: environment === Environment.DEV ? false : true,
  setMaintenance: (value) => set({ maintenanceDev: value }),
}));
